import React, { useEffect } from "react";
import { required, SelectInput, useGetList } from "react-admin";
import { useFormContext } from "react-hook-form";
import { studentRequests } from "api/studentApi";

const CourseInput = ({ curriculumId, disciplineId, defaultValues }) => {
  const { setValue } = useFormContext();

  const { data, isLoading } = useGetList(
    studentRequests.getCurriculumDisciplineCoursesSelect(curriculumId, disciplineId),
    {},
    { enabled: !!curriculumId && !!disciplineId },
  );

  useEffect(() => {
    if (defaultValues) {
      setValue("course", defaultValues, { shouldDirty: false });
    } else if (!isLoading && data?.length) {
      setValue("course", data[0].id);
    }
  }, [isLoading, data, setValue, defaultValues]);

  return (
    <SelectInput
      source="course"
      label="Курс"
      choices={data ?? []}
      isLoading={isLoading}
      optionValue="id"
      optionText="name"
      fullWidth
      validate={[required()]}
    />
  );
};

export default CourseInput;
